import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './archive-egress-guard';
import CoreFullApp from './CoreFullApp';
import { bootstrapUniverse } from './bootstrap-universe';
import './last-visible-theme-runtime';
import './creative-libraries.css';
import './stage-controls.css';
import './editor-shell.css';
import './wall-card-refinement.css';
import './wall-card-responsive.css';
import './wall-profile-drawer.css';
import './wall-profile-legacy.css';
import './wall-v1-dossier.css';
import './wall-footer-and-editor-header.css';
import './editor-density-and-sidebar.css';
import './wall-v1-dossier-runtime';
import './editor-shell';
import './sidebar-collapse';
import './mind-map-route-runtime';
import './mind-map-line-rules-position';
import './mind-map-relationship-polish.css';
import './card-theme-library-runtime';
import './interface-theme-customizer-runtime';
import './interface-background-customizer-runtime';
import './interface-theme-label-help-runtime';
import './library-quick-add-runtime';
import './recent-colors-runtime';
import './library-card-identity-runtime';
import './library-preferences-runtime';
import './library-metadata-runtime';
import './library-group-flow-runtime';
import './library-group-stability-runtime';
import './library-drag-autoscroll-runtime';
import './extra-small-library-runtime';
import './wall-dossier-resize-fix';
import './editor-connections-runtime';
import './editor-library-suggestions';
import './point-ledger-runtime';
import './profile-identity-runtime';
import './sidebar-quotes-runtime';
import './rider-threshing-runtime';
import './harvest-runtime';
import './harvest-ui-authority-runtime';
import './rider-replay-threshing-runtime';
import './prythian-progression-runtime';
import './empyrean-rank-gate-runtime';
import './extra-small-library.css';
import './library-card-sizing-fix.css';
import './core-theme-system.css';
import './prythian-court-atmospheres.css';
import './night-court-experience.css';
import './prythian-core-overrides.css';
import './rider-core-experience.css';
import './mobile-core-polish.css';
import './library-card-responsive-final.css';
import './library-card-interactions.css';
import './editor-connections-runtime.css';
import './library-card-layout-authority.css';
import './interaction-layer-authority.css';
import './point-ledger-runtime.css';
import './profile-identity-runtime.css';
import './path-profile-separation.css';
import './library-quick-add-runtime.css';
import './global-scrollbars.css';
import './theme-glass-authority.css';
import './interface-theme-customizer.css';
import './interface-theme-final-authority.css';
import './interface-background-authority.css';
import './interface-theme-label-help.css';
import './interface-theme-launcher-position.css';
import './library-settings-collapse.css';
import './profile-drawer-and-sidebar-authority.css';
import './library-group-universal-authority.css';
import './library-scroll-authority.css';
import './mobile-card-editor-authority.css';
import './mobile-overflow-authority.css';

bootstrapUniverse();

const root = document.getElementById('root');
if (!root) throw new Error('V2 application root was not found.');

createRoot(root).render(
  <StrictMode>
    <CoreFullApp />
  </StrictMode>,
);
